export default {
  namespaced: true,
  state: {
    primary: 'magenta',
    header: 'magenta',
  },
  getters: {
    primary: (s) => s.primary,
    header: (s) => s.header,
  },
  mutations: {
    COLORS_SET(state, { primary, header }) {
      if (primary) state.primary = primary;
      if (header) state.header = header;
    },
  },
  actions: {
    setColors({ commit }, { primary, header } = {}) {
      commit('COLORS_SET', { primary, header });
    },
  },
};
